export const NATIVE_REGION_NAMES: { [regionCode: string]: string } = {
  AD: 'Andorra',
  AE: 'دولة الإمارات العربية المتحدة',
  AF: 'افغانستان',
  AG: 'Antigua and Barbuda',
  AI: 'Anguilla',
  AL: 'Shqipëria',
  AM: 'Հայաստան',
  AN: 'Nederlandse Antillen',
  AO: 'Angola',
  AQ: 'Antarctica',
  AR: 'Argentina',
  AS: 'American Samoa',
  AT: 'Österreich',
  AU: 'Australia',
  AW: 'Aruba',
  AX: 'Åland',
  AZ: 'Azərbaycan',
  BA: 'Bosna i Hercegovina',
  BB: 'Barbados',
  BD: 'Bangladesh',
  BE: 'België',
  BF: 'Burkina Faso',
  BG: 'България',
  BH: '‏البحرين',
  BI: 'Burundi',
  BJ: 'Bénin',
  BL: 'Saint-Barthélemy',
  BM: 'Bermuda',
  BN: 'Negara Brunei Darussalam',
  BO: 'Bolivia',
  BQ: 'Bonaire',
  BR: 'Brasil',
  BS: 'Bahamas',
  BT: 'ʼbrug-yul',
  BV: 'Bouvetøya',
  BW: 'Botswana',
  BY: 'Белару́сь',
  BZ: 'Belize',
  CA: 'Canada',
  CC: 'Cocos (Keeling) Islands',
  CD: 'République démocratique du Congo',
  CF: 'Ködörösêse tî Bêafrîka',
  CG: 'République du Congo',
  CH: 'Schweiz',
  CI: 'Côte d\'Ivoire',
  CK: 'Cook Islands',
  CL: 'Chile',
  CM: 'Cameroon',
  CN: '中国',
  CO: 'Colombia',
  CR: 'Costa Rica',
  CU: 'Cuba',
  CV: 'Cabo Verde',
  CW: 'Curaçao',
  CX: 'Christmas Island',
  CY: 'Κύπρος',
  CZ: 'Česká republika',
  DE: 'Deutschland',
  DJ: 'Djibouti',
  DK: 'Danmark',
  DM: 'Dominica',
  DO: 'República Dominicana',
  DZ: 'الجزائر',
  EC: 'Ecuador',
  EE: 'Eesti',
  EG: 'مصر‎',
  EH: 'الصحراء الغربية',
  ER: 'ኤርትራ',
  ES: 'España',
  ET: 'ኢትዮጵያ',
  FI: 'Suomi',
  FJ: 'Fiji',
  FK: 'Falkland Islands',
  FM: 'Micronesia',
  FO: 'Føroyar',
  FR: 'France',
  GA: 'Gabon',
  GB: 'United Kingdom',
  GD: 'Grenada',
  GE: 'საქართველო',
  GF: 'Guyane française',
  GG: 'Guernsey',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GL: 'Kalaallit Nunaat',
  GM: 'Gambia',
  GN: 'Guinée',
  GP: 'Guadeloupe',
  GQ: 'Guinea Ecuatorial',
  GR: 'Ελλάδα',
  GS: 'South Georgia',
  GT: 'Guatemala',
  GU: 'Guam',
  GW: 'Guiné-Bissau',
  GY: 'Guyana',
  HK: '中国香港',
  HM: 'Heard Island and McDonald Islands',
  HN: 'Honduras',
  HR: 'Hrvatska',
  HT: 'Haïti',
  HU: 'Magyarország',
  ID: 'Indonesia',
  IE: 'Éire',
  IL: 'יִשְׂרָאֵל',
  IM: 'Isle of Man',
  IN: 'भारत',
  IO: 'British Indian Ocean Territory',
  IQ: 'العراق',
  IR: 'ایران',
  IS: 'Ísland',
  IT: 'Italia',
  JE: 'Jersey',
  JM: 'Jamaica',
  JO: 'الأردن',
  JP: '日本',
  KE: 'Kenya',
  KG: 'Кыргызстан',
  KH: 'Kâmpŭchéa',
  KI: 'Kiribati',
  KM: 'Komori',
  KN: 'Saint Kitts and Nevis',
  KP: '북한',
  KR: '대한민국',
  KW: 'الكويت',
  KY: 'Cayman Islands',
  KZ: 'Қазақстан',
  LA: 'ສປປລາວ',
  LB: 'لبنان',
  LC: 'Saint Lucia',
  LI: 'Liechtenstein',
  LK: 'śrī laṃkāva',
  LR: 'Liberia',
  LS: 'Lesotho',
  LT: 'Lietuva',
  LU: 'Luxembourg',
  LV: 'Latvija',
  LY: '‏ليبيا',
  MA: 'المغرب',
  MC: 'Monaco',
  MD: 'Moldova',
  ME: 'Црна Гора',
  MF: 'Saint-Martin',
  MG: 'Madagasikara',
  MH: 'M̧ajeļ',
  MK: 'Северна Македонија',
  ML: 'Mali',
  MM: 'မြန်မာ',
  MN: 'Монгол улс',
  MO: '澳門',
  MP: 'Northern Mariana Islands',
  MQ: 'Martinique',
  MR: 'موريتانيا',
  MS: 'Montserrat',
  MT: 'Malta',
  MU: 'Maurice',
  MV: 'Maldives',
  MW: 'Malawi',
  MX: 'México',
  MY: 'Malaysia',
  MZ: 'Moçambique',
  NA: 'Namibia',
  NC: 'Nouvelle-Calédonie',
  NE: 'Niger',
  NF: 'Norfolk Island',
  NG: 'Nigeria',
  NI: 'Nicaragua',
  NL: 'Nederland',
  NO: 'Norge',
  NP: 'नपल',
  NR: 'Nauru',
  NU: 'Niuē',
  NZ: 'New Zealand',
  OM: 'عمان',
  PA: 'Panamá',
  PE: 'Perú',
  PF: 'Polynésie française',
  PG: 'Papua Niugini',
  PH: 'Pilipinas',
  PK: 'Pakistan',
  PL: 'Polska',
  PM: 'Saint-Pierre-et-Miquelon',
  PN: 'Pitcairn Islands',
  PR: 'Puerto Rico',
  PS: 'فلسطين',
  PT: 'Portugal',
  PW: 'Palau',
  PY: 'Paraguay',
  QA: 'قطر',
  RE: 'La Réunion',
  RO: 'România',
  RS: 'Србија',
  RU: 'Россия',
  RW: 'Rwanda',
  SA: 'العربية السعودية',
  SB: 'Solomon Islands',
  SC: 'Seychelles',
  SD: 'السودان',
  SE: 'Sverige',
  SG: 'Singapore',
  SH: 'Saint Helena',
  SI: 'Slovenija',
  SJ: 'Svalbard og Jan Mayen',
  SK: 'Slovensko',
  SL: 'Sierra Leone',
  SM: 'San Marino',
  SN: 'Sénégal',
  SO: 'Soomaaliya',
  SR: 'Suriname',
  SS: 'South Sudan',
  ST: 'São Tomé e Príncipe',
  SV: 'El Salvador',
  SX: 'Sint Maarten',
  SY: 'سوريا',
  SZ: 'Swaziland',
  TC: 'Turks and Caicos Islands',
  TD: 'Tchad',
  TF: 'Territoire des Terres australes et antarctiques fr',
  TG: 'Togo',
  TH: 'ประเทศไทย',
  TJ: 'Тоҷикистон',
  TK: 'Tokelau',
  TL: 'Timor-Leste',
  TM: 'Türkmenistan',
  TN: 'تونس',
  TO: 'Tonga',
  TR: 'Türkiye',
  TT: 'Trinidad and Tobago',
  TV: 'Tuvalu',
  TW: '中国台湾',
  TZ: 'Tanzania',
  UA: 'Україна',
  UG: 'Uganda',
  UM: 'United States Minor Outlying Islands',
  US: 'United States of America',
  UY: 'Uruguay',
  UZ: 'O‘zbekiston',
  VA: 'Vaticano',
  VC: 'Saint Vincent and the Grenadines',
  VE: 'Venezuela',
  VG: 'British Virgin Islands',
  VI: 'United States Virgin Islands',
  VN: 'Việt Nam',
  VU: 'Vanuatu',
  WF: 'Wallis et Futuna',
  WS: 'Samoa',
  XK: 'Republika e Kosovës',
  YE: 'اليَمَن',
  YT: 'Mayotte',
  ZA: 'South Africa',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
}
